import { Button, Typography } from "@material-ui/core"
import {
  Contact,
  DriveTestReservation,
  ShowRoom,
  postContactDriveTestReservation,
  postContactEcommContact,
} from "api"
import FormikCheckboxField from "common/FormikCheckboxField"
import { useIsDesktop } from "common/MediaQueries"
import {
  trackPersonalDetails,
  trackPopUpClicks,
  trackPopUpOpen,
  trackSuccessLead,
} from "common/analytics"
import FormikForm from "common/bit/form/FormikForm"
import { getUtmParamsAsKeyValueList } from "common/bit/utils/utmParams"
import { postCallboxLead } from "common/postCallboxLead"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import FormErrorState from "reusable/formsComp/FormErrorState"
import FormInput from "reusable/formsComp/FormInput"
import FormSelect, { toFormSelectOptions } from "reusable/formsComp/FormSelect"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import styled from "styled-components"
import schemaTestDrive from "./SchemaTestDrive"
import schemaTestDriveContact from "./SchemaTestDriveContact"

const StyledClassicPopUp = styled(ClassicPopUp)<{
  $isModelPage?: boolean
  $isIframe?: boolean
}>`
  .MuiDialog-paper {
    ${(p) =>
      p?.$isIframe &&
      `
    width: 960px;
    max-width: 100% !important;
    ${p.theme.breakpoints.down("sm")} {
        &.mobile-margin{
          width: calc(100% - 30px);
        }
      }
    `}
  }
  ${(p) =>
    p?.$isModelPage &&
    `
  .MuiPaper-root {
    margin: 30px 0;
  }`}
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    .MuiFormControl-root {
      margin-top: 10px;
    }
  }
`
const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
`
const StyledButton = styled(Button)`
  margin: 20px 0px;
  height: 45px;
  background: ${(p) => p?.theme?.colors?.black};
  color: white;
  :hover {
    background: ${(p) => p?.theme?.colors?.steel};
    outline: none;
  }
  &:focus-visible {
    border: 2px dashed white;
    outline: 3px dashed #0e3487;
    outline-offset: 2px;
  }
`
const StyledRowCol = styled.div<{ $type?: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
    margin-bottom: 30px;
  }

  ${(p) => p?.$type === "mail" && "margin-bottom: 20px !important;"}
`
const StyledWrap = styled.div`
  width: 100%;
  max-width: 320px;
`
const StyledRequiredFields = styled(Typography).attrs({ variant: "caption" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-left: auto;
`

const StyledFormSelect = styled(FormSelect)<{
  $isShop?: boolean
  $isModelPage?: boolean
}>`
  width: 296px;

  .MuiSelect-root {
    &:focus-visible {
      border: 0;
      outline: 0;
    }
  }

  ${(p) =>
    p?.$isShop &&
    `
    width: 296px;

    label {
      position: relative;
      top: ${p?.$isModelPage ? "16px" : "10px"};
      right: 10px;
    }

    label[class*="MuiInputLabel-shrink"] {
      transform: translate(8px, -6px) scale(0.75);
    }
  `}

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledFormInput = styled(FormInput)`
  legend {
    width: 0;
  }
`

const StyledFormikCheckboxField = styled(FormikCheckboxField)`
  margin-top: 30px;
  span {
    user-select: none;
    font-size: 16px;
  }

  span[class*="PrivateSwitchBase-root"] {
    padding: 0 9px 9px 9px;
    &:focus {
      border: 2px dashed white;
      outline: 3px dashed #0e3487;
      outline-offset: 2px;
    }
  }
`

const getFormName = (formType) => {
  if (formType === "meeting") return "Mazda_meeting_form"
  if (formType === "financing") return "Mazda_funding_form"
  if (formType === "test-drive") return "Mazda_test_drive_form"
  return "Mazda_meeting_form"
}

type itemProps = {
  id: string
  name: string
}

export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}

type PopupProps = {
  onClose: () => void
  open: boolean
  showRoomsList: ShowRoom[]
  modelsOptions?: {}[]
  contactForm?: boolean
  dialogClass?: string
  title?: string
  buttonText?: string
  formType?: "test-drive" | "contact"
  modelId?: number
  userInfo?: any
  analyticName?: string
  isShop?: boolean
}

const TestDrivePopup = ({
  onClose,
  open,
  showRoomsList,
  modelsOptions = [],
  contactForm,
  dialogClass,
  buttonText,
  formType,
  title,
  modelId,
  userInfo,
  analyticName,
  isShop,
}: PopupProps) => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const showRoomsOptions = toFormSelectOptions(showRoomsList, "id", "name")
  const models = toFormSelectOptions(modelsOptions, "id", "name")

  const isDesktop = useIsDesktop()
  const { query, pathname } = useRouter()

  const isModelPage = pathname.indexOf("/model") === 0

  const initialValues = {
    firstName: userInfo?.firstName || "",
    lastName: userInfo?.lastName || "",
    mobilePhone: userInfo?.mobilePhone || "",
    emailAddress: userInfo?.emailAddress || "",
    showRoom: "",
    over18: false,
    terms: false,
    isMailing: false,
    carModel: "",
    phoneNumber: userInfo?.mobilePhone || "",
    email: userInfo?.emailAddress || "",
    approveMailing: false,
  }

  useEffect(() => {
    if (open) {
      trackPopUpOpen(analyticName ? analyticName : "test drive")
    }
    if (!open) {
      setFormStatus(FormStatus.Normal)
    }
  }, [open])

  const checkboxLabel = `אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.
  `

  return (
    <StyledClassicPopUp
      open={open}
      onClose={onClose}
      title={title}
      dialogClass={dialogClass}
      hasError={formStatus === FormStatus.Error}
      $isModelPage={isModelPage}
    >
      <StyledWrapper>
        {formStatus === FormStatus.Normal && (
          <FormikForm
            validationSchema={
              contactForm ? schemaTestDriveContact : schemaTestDrive
            }
            initialValues={initialValues}
            onSubmit={async (values) => {
              const utmValues = getUtmParamsAsKeyValueList()

              // carmodelId or modelId prop, or query.modelId or values.carModel or 0
              const carModelId =
                modelId ||
                parseInt(query.modelId as string) ||
                parseInt(values.carModel) ||
                0

              const request =
                formType === "test-drive"
                  ? {
                      carModelId: carModelId,
                      showRoomId: values.showRoom
                        ? parseInt(values.showRoom)
                        : 0,
                      firstName: values.firstName,
                      lastName: values.lastName,
                      phone: values.phoneNumber,
                      email: values.email,
                      contactSource: isDesktop ? "Pc" : "Mobile",
                      utmValues,
                      approveMailingList: values.isMailing,
                      sid: window?.__ctm?.config?.sid || "",
                      formName: getFormName(formType),
                    }
                  : {
                      fullName: `${values.firstName} ${values.lastName}`,
                      phone: values.phoneNumber,
                      description: "",
                      mediaChannelId: "",
                      branchId: Number(values.showRoom),
                      modelId: carModelId ?? null,
                      platform: isDesktop ? "Pc" : "Mobile",
                      isMailing: values?.isMailing,
                      utmValues,
                      emailAddress: values?.email,
                      sid: window?.__ctm?.config?.sid || "",
                      formName: getFormName(formType),
                    }

              try {
                const { data } =
                  formType === "test-drive"
                    ? await postContactDriveTestReservation(
                        request as DriveTestReservation
                      )
                    : await postContactEcommContact(request as Contact)
                postCallboxLead(formType, request)
                if (data.body) {
                  trackSuccessLead(
                    analyticName ? analyticName : "test drive",
                    "lead_success"
                  )
                  trackPersonalDetails(
                    formType === "test-drive" ? "TestDrive" : "Meeting",
                    values.email,
                    values.phoneNumber,
                    false
                  )
                  setFormStatus(FormStatus.Success)
                } else {
                  setFormStatus(FormStatus.Error)
                }
              } catch (error) {
                console.log(error)
                setFormStatus(FormStatus.Error)
              }
            }}
            render={(formik) => (
              <StyledFormDiv>
                <StyledRequiredFields>* שדות חובה</StyledRequiredFields>
                <StyledRowCol>
                  <StyledFormInput
                    name="firstName"
                    label="שם פרטי"
                    required
                    autoComplete="given-name"
                    onFocusCapture={() =>
                      trackPopUpClicks(
                        analyticName ? analyticName : "test drive",
                        "firstName"
                      )
                    }
                    marginTop={isDesktop ? 10 : 0}
                  />
                  <StyledFormInput
                    name="lastName"
                    label="שם משפחה"
                    required
                    autoComplete="family-name"
                    onFocusCapture={() =>
                      trackPopUpClicks(
                        analyticName ? analyticName : "test drive",
                        "lastName"
                      )
                    }
                    marginTop={isDesktop ? 10 : 0}
                  />
                </StyledRowCol>
                <StyledRowCol $type="mail">
                  <StyledFormInput
                    marginTop={0}
                    name="email"
                    label="כתובת מייל"
                    required
                    type="email"
                    autoComplete="email"
                    onFocusCapture={() =>
                      trackPopUpClicks(
                        analyticName ? analyticName : "test drive",
                        "email"
                      )
                    }
                  />
                  <StyledFormInput
                    marginTop={0}
                    name="phoneNumber"
                    label="טלפון נייד"
                    type="tel"
                    required
                    autoComplete="tel-national"
                    onFocusCapture={() =>
                      trackPopUpClicks(
                        analyticName ? analyticName : "test drive",
                        "phoneNumber"
                      )
                    }
                  />
                </StyledRowCol>
                {contactForm && (
                  <FormSelect
                    name="carModel"
                    required
                    label="בחירת דגם רכב"
                    values={models}
                    map={(item) => ({ id: item.id, name: item.name })}
                    onClick={() =>
                      trackPopUpClicks(
                        analyticName ? analyticName : "test drive",
                        "carModel"
                      )
                    }
                  />
                )}
                <StyledFormSelect
                  $isShop={isShop}
                  $isModelPage={isModelPage}
                  marginTop={0}
                  name="showRoom"
                  required
                  label="בחירת אולם תצוגה"
                  values={showRoomsOptions}
                  map={(item: itemProps) => ({ id: item.id, name: item.name })}
                  onClick={() =>
                    trackPopUpClicks(
                      analyticName ? analyticName : "test drive",
                      "showRoom"
                    )
                  }
                />
                <StyledFormikCheckboxField
                  name="isMailing"
                  label={checkboxLabel}
                  required
                  classes={{ root: "orderCheckbox" }}
                />
                <StyledWrap>
                  <StyledButton
                    disabled={formik.isSubmitting}
                    fullWidth
                    variant="text"
                    type={"submit"}
                  >
                    {buttonText || "חִזרו אליי לתיאום הנסיעה"}
                  </StyledButton>
                </StyledWrap>
              </StyledFormDiv>
            )}
          />
        )}
        {formStatus === FormStatus.Error && <FormErrorState />}
        {formStatus === FormStatus.Success && <FormSuccessState />}
      </StyledWrapper>
    </StyledClassicPopUp>
  )
}

export default TestDrivePopup
